import { browserStorage } from "@/utils/browserStorage";

const INSPECTOR_OPEN_STORAGE_KEY = "exordos-interface-builder-inspector-open";
const INSPECTOR_WINDOW_STORAGE_KEY =
  "exordos-interface-builder-inspector-window";

export interface InterfaceBuilderInspectorWindowState {
  expandedNodeIds: string[];
  height: number;
  left: number;
  top: number;
  treeHeight: number;
  width: number;
}

export function readInterfaceBuilderInspectorOpen(): boolean {
  const stored = browserStorage.get(INSPECTOR_OPEN_STORAGE_KEY);

  if (stored === "false") return false;
  return true;
}

export function writeInterfaceBuilderInspectorOpen(open: boolean): void {
  browserStorage.set(INSPECTOR_OPEN_STORAGE_KEY, String(open));
}

export function readInterfaceBuilderInspectorWindowState():
  InterfaceBuilderInspectorWindowState | null {
  const stored = browserStorage.get(INSPECTOR_WINDOW_STORAGE_KEY);
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored) as Partial<InterfaceBuilderInspectorWindowState>;
    if (!isFiniteNumber(parsed.left) || !isFiniteNumber(parsed.top)) {
      return null;
    }
    if (!isFiniteNumber(parsed.width) || !isFiniteNumber(parsed.height)) {
      return null;
    }
    if (!isFiniteNumber(parsed.treeHeight)) {
      return null;
    }

    return {
      expandedNodeIds: Array.isArray(parsed.expandedNodeIds)
        ? parsed.expandedNodeIds.filter((id): id is string => (
          typeof id === "string" && Boolean(id)
        ))
        : [],
      height: parsed.height,
      left: parsed.left,
      top: parsed.top,
      treeHeight: parsed.treeHeight,
      width: parsed.width,
    };
  } catch {
    return null;
  }
}

export function writeInterfaceBuilderInspectorWindowState(
  state: InterfaceBuilderInspectorWindowState,
): void {
  browserStorage.set(INSPECTOR_WINDOW_STORAGE_KEY, JSON.stringify(state));
}

function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}
